/**
 * @Description: 用于存储标签边框分类的多语言文言内容相关接口
 */
import { ContentType, Method } from 'axios-mapper'
import https from '@/utils/https'
import { RootObject } from '@/model/rootObject'
import { PageRespModel } from '@/model/pageRespModel'
import { Route } from '@/constant/route'
import {
  LabelFrameCategoryLanguageModel,
  LabelFrameCategoryLanguageSearchModel,
  LabelFrameCategoryLanguagePageSearchModel,
  LabelFrameCategoryLanguageAddModel,
  LabelFrameCategoryLanguageUpdateModel,
  IdsModel
} from '@/model/product/LabelFrameCategoryLanguageModel'

const baseUrl = Route.product + '/labelFrameCategoryLanguage'

/**
 * 搜索分页数据
 */
export const pageSearchLabelFrameCategoryLanguage = (param: LabelFrameCategoryLanguagePageSearchModel) => {
  return https().request<RootObject<PageRespModel<LabelFrameCategoryLanguageModel>>>(baseUrl.concat('/list'), Method.POST, param, ContentType.json)
}

/**
 * 搜索所有数据
 */
export const searchLabelFrameCategoryLanguage = (param: LabelFrameCategoryLanguageSearchModel) => {
  return https().request<RootObject<LabelFrameCategoryLanguageModel[]>>(baseUrl.concat('/list/all'), Method.POST, param, ContentType.json)
}

/**
 * 根据ID查找数据
 */
export const getLabelFrameCategoryLanguage = (id: number) => {
  return https().request<RootObject<LabelFrameCategoryLanguageModel>>(baseUrl.concat('/get/').concat(id.toString()), Method.GET, undefined, ContentType.json)
}

/**
 * 添加数据
 */
export const addLabelFrameCategoryLanguage = (param: LabelFrameCategoryLanguageAddModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/add'), Method.POST, param, ContentType.json)
}

/**
 * 更新数据
 */
export const updateLabelFrameCategoryLanguage = (param: LabelFrameCategoryLanguageUpdateModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/update'), Method.POST, param, ContentType.json)
}

/**
 * 删除数据
 */
export const removeLabelFrameCategoryLanguage = (id: number) => {
  return https().request<RootObject<any>>(baseUrl.concat('/remove/').concat(id.toString()), Method.POST, undefined, ContentType.json)
}

/**
 * 批量删除数据
 */
export const batchRemoveLabelFrameCategoryLanguage = (param: IdsModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/batch/remove'), Method.POST, param, ContentType.json)
}
